module.exports = __webpack_public_path__ + "img/vue1-lacet_blanc.fb840f96.png";